import React, { useEffect, useRef, useState } from 'react';
import Lottie from 'lottie-react';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
}) => {
  const modal = useRef<HTMLDivElement>(null);
  const [animationData, setAnimationData] = useState<any>(null);

  // 🔄 Cargar animación SOLO cuando se abre el modal
  useEffect(() => {
    if (isOpen) {
      import('../../assets/animations/alerts/alerta-success.json').then((data) => {
        setAnimationData(data.default);
      });
    } else {
      setAnimationData(null); // Limpia cuando se cierra (opcional)
    }
  }, [isOpen]);

  // 🔒 Cerrar modal al hacer clic fuera
  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      if (modal.current && !modal.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', clickHandler);
    return () => document.removeEventListener('mousedown', clickHandler);
  }, [onClose]);

  // ⎋ Cerrar con tecla ESC o Enter
  useEffect(() => {
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (isOpen && (keyCode === 27 || keyCode === 13)) {
        onClose();
      }
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed left-0 top-0 z-[999999] flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
      <div
        ref={modal}
        className="w-full max-w-md rounded-lg bg-white px-8 py-12 text-center dark:bg-boxdark"
      >
        {/* ✅ Animación solo si ya se cargó */}
        {animationData && (
          <div className="flex justify-center mb-2">
            <Lottie animationData={animationData} loop={false} style={{ width: 60, height: 60 }} />
          </div>
        )}

        <h3 className="pb-2 text-xl font-bold text-[#3CA745] dark:text-[#3CA745] sm:text-2xl">
          {title}
        </h3>

        <p className="text-gray-800 dark:text-gray-300 mb-6">{message}</p>

        <button
          onClick={onClose}
          className="block w-full rounded border border-[#3CA745] bg-[#3CA745] p-3 text-center font-medium text-white transition hover:bg-opacity-90"
        >
          Entendido
        </button>
      </div>
    </div>
  );
};

export default React.memo(SuccessModal);
